import React from "react";
import { Navigate } from "react-router-dom";
import IdleLogoutGuard from "./components/IdleLogoutGuard";

function StudentProtectedRoute({ children }) {
  const studentData = localStorage.getItem("student");

  if (!studentData) {
    return <Navigate to="/student-login" replace />;
  }

  return (
    <IdleLogoutGuard
      enabled={Boolean(studentData)}
      authKey="student"
      activityKey="studentLastActiveAt"
      clearKeys={["student"]}
      redirectTo="/student-login"
    >
      {children}
    </IdleLogoutGuard>
  );
}

export default StudentProtectedRoute;
